module.exports = __webpack_public_path__ + "static/media/plane(24).6859b540.PNG";